import React, { useState, useEffect } from "react";
import moment from "moment";
import "./../UI Component/Modal/Modal.css";
import "./styles.scss";
import afterLoginApiAxios from "../../Util/API Calls/afterLogin";
import BookSchedule from "../BookSchedule/BookSchedule";
import Calendar from "react-calendar";
import "./../../globalStyles/calendarStyle.scss";
import CalenderIcon from "../../assets/calender_icon.png";
import DownArrowIcon from "../../assets/filled-down-arrow.png";
import swal from "sweetalert";
import CustomSelect from "../UI Component/CustomSelect/CustomSelect";
import { LOCALSTORAGEKEY } from "../../Util/Helper/localStorageUtils";
import ResourceChipSection from "./ResourceChipSection";
import NoDataComponent from "../common/NoDataUI/NoDataComponent";
import SelectDoctor from "../../assets/selectDoctor.svg";
import { C2CConsole } from "../../Util/Helper/C2CConsole";
import { IOSSwitch } from "../DoctorComponents/MyScheduleFees/UpdateSchedule/IOSSwitch";
import { c2cPostApiHandler } from "../../Util/c2cApiHandler";

function BookingCalendar(props) {
  const {
    disableSaveBtn,
    bookingFromFollowUpDashboard,
    selectedProcedureList,
    selectedResourceProcedure,
    handleSelectChip,
    handleRemoveChip,
    handleSelectResourceSlot,
    hasResourceAccess,
    handleDateToResetResource,
    addBooking,
    allowCalendarChange,
    selectedBookingType,
    state,
    booking_type,
    isAbhaTokenBooking,
    allotedPremiumSlot,
    retainedSlot,
    retainedSlotObj,
    setAllotedPremiumSlot,
    showPremiumSlotSelection,
    setShowPremiumSlotSelection,
    handlePremiumToggleSwitch,
    setSelectedProcedureList,
    apiSelectedConsultation,
    setApiConsultationTypeValue,
    calenderDate,
    setCalenderDate,
    dashboardSelectedDate,
    middleContent,
    showAllotedPremiumSlot,
    setShowAllotedPremiumSlot,
    isLeadBooking,
    followUpBooking,
  } = props;
  const [pgLoading, setPgLoading] = useState(false);
  const [lessThan15, setLessThan] = useState(false);
  const [selectedDate, setSelectedDate] = useState();
  const [fromCalender, setFromCalender] = useState(false);
  const [showCalendar, setShowCalendar] = useState(false);
  const [duration, setDuration] = useState(false);
  let [track, changeTrack] = useState(1);
  const [errorTime, setErrorTime] = useState();
  const [timer, setTimer] = useState({});
  const [errors, setErrors] = useState({});

  const onlineConsultationType = [
    {
      sid: 0,
      id: 0,
      value: 0,
      label: "Tele-Consult Regular",
    },
    {
      sid: 1,
      id: 1,
      value: 1,
      label: "Tele-Consult Follow-up",
    },
  ];

  const [inClinicConsultationType, setInClinicConsultationType] = useState([
    {
      sid: 5,
      id: 5,
      value: 5,
      label: "In-Clinic Regular",
    },
    {
      sid: 6,
      id: 6,
      value: 6,
      label: "In-Clinic Follow-up",
    },
  ]);

  const SaveBtnContainerClassName =
    (hasResourceAccess || addBooking) && state === 1
      ? "sc-btn-div-resource"
      : "sc-btn-div";

  //LifeCycle Methods ==>
  useEffect(() => {
    if (showPremiumSlotSelection) {
      let startTime = "";
      let endTime = "";
      if (hasResourceAccess || addBooking) {
        let selected = selectedProcedureList.find(
          (ob) => ob.id === selectedResourceProcedure.id
        );
        if (selected) {
          startTime = selected["alloted_custom_slot"]?.startTime
            ? moment(selected["alloted_custom_slot"]?.startTime, "hh:mm A")
            : moment(new Date());
          endTime = selected["alloted_custom_slot"]?.endTime
            ? moment(selected["alloted_custom_slot"]?.endTime, "hh:mm A")
            : moment(new Date(new Date().getTime() + duration * 60 * 1000));
        } else {
          startTime = moment(new Date(), "hh:mm A");
          endTime = moment(new Date(), "hh:mm A");
        }
      } else {
        startTime = allotedPremiumSlot?.startTime
          ? moment(allotedPremiumSlot?.startTime, "hh:mm A")
          : moment(new Date());
        endTime = allotedPremiumSlot?.endTime
          ? moment(allotedPremiumSlot?.endTime, "hh:mm A")
          : moment(new Date(new Date().getTime() + duration * 60 * 1000));
      }
      setTimer({
        start_hr: startTime.format("hh"),
        start_min: startTime.format("mm"),
        start_meridian: startTime.format("A"),
        end_hr: endTime.format("hh"),
        end_min: endTime.format("mm"),
        end_meridian: endTime.format("A"),
      });
    }
  }, [showPremiumSlotSelection, selectedResourceProcedure]);

  useEffect(() => {
    checkErrors();
  }, [timer, calenderDate]);

  useEffect(() => {
    if (
      (hasResourceAccess || addBooking) &&
      selectedProcedureList.length === 0
    ) {
      setShowPremiumSlotSelection(false);
    }
  }, []);

  useEffect(() => {
    if (hasResourceAccess || addBooking) {
      isCustomSlotChecked();
    }
  }, [
    selectedProcedureList,
    selectedResourceProcedure,
    hasResourceAccess,
    addBooking,
    showPremiumSlotSelection,
  ]);

  useEffect(() => {
    if (!hasResourceAccess && !addBooking) {
      setPgLoading(true);
    }
    if (props.appointmentType == "in-clinic") {
      if (Object.keys(apiSelectedConsultation)?.length === 0) {
        setApiConsultationTypeValue(inClinicConsultationType[0]);
      }
      const clinicId = localStorage.getItem(LOCALSTORAGEKEY.CLINIC_ID);
      let payload = {
        doctor_id: props?.doctor?.doctor_id,
      };
      if (clinicId !== "" && clinicId !== undefined && clinicId !== null) {
        payload["clinic_id"] = clinicId;
      }
      afterLoginApiAxios({
        method: "post",
        url:
          clinicId !== "" && clinicId !== undefined && clinicId !== null
            ? "/clinic/get-clinic-consultation-type-list"
            : "/public/get-doctor-consultation-type-list",

        headers: {
          authorization: localStorage.getItem("id_token"),
        },
        data: payload,
      })
        .then((response) => {
          if (response) {
            var responseData = response.data;
            if (responseData) {
              if (response?.data?.hasOwnProperty("statusCode")) {
                if (response?.data?.statusCode == 200) {
                  response?.data?.doctor_consultation_detail?.length &&
                    response.data.doctor_consultation_detail.map(
                      (data, index) => {
                        if (data?.consultation_type === "4") {
                          if (data?.procedure_list?.length > 0) {
                            // let arr = [];
                            let inClinicSelectOptions =
                              inClinicConsultationType;
                            data.procedure_list.map((pdata, indx) => {
                              let obj = {};
                              obj["sid"] = 4 + (indx + 2); // to avoid conflict with In-clinic Regular and In-clinic follow-u
                              obj["id"] = data.consultation_type;
                              obj["value"] = pdata.procedure_id;
                              obj["label"] = pdata.procedure_name;
                              // arr.push(obj)
                              inClinicSelectOptions.push(obj);
                            });
                            // let inClinicSelectOptions = inClinicConsultationType;
                            // inClinicSelectOptions.push(arr);
                            setInClinicConsultationType(inClinicSelectOptions);
                          }
                        }
                      }
                    );
                  setPgLoading(false);
                } else {
                  setPgLoading(false);
                }
              }
            }
          }
        })
        .catch((error) => {
          C2CConsole.error(error);
          if (error.response?.status === 403) {
            C2CConsole.error("403 - unauth");
          }
        });
    } else {
      if (Object.keys(apiSelectedConsultation)?.length === 0) {
        setApiConsultationTypeValue(onlineConsultationType[0]);
      }
      setPgLoading(false);
    }
  }, []);

  // Actions ==>

  const handleDate = (date) => {
    setCalenderDate(date);
    setFromCalender(true);
    setShowCalendar(false);
    changeTrack(++track);
    setAllotedPremiumSlot({
      startTime: "",
      endTime: "",
      slot_id: "",
    });
  };

  const handleConsultationType = (value) => {
    handleDate(calenderDate);
    props.handleIsFollowUp(value);
    setApiConsultationTypeValue(value);
    setAllotedPremiumSlot({
      startTime: "",
      endTime: "",
      slot_id: "",
    });
  };
  const isCustomSlotChecked = () => {
    if (hasResourceAccess || addBooking) {
      let selected = selectedProcedureList.find(
        (obj) => obj.id === selectedResourceProcedure.id
      );
      setShowPremiumSlotSelection(selected?.custom_slot ? true : false);
    }
  };

  const getSlotTime = (value, slotObj) => {
    let selectedData = `${moment(selectedDate.meta._d, "DD-MM-YYYY").format(
      "DD-MM-YYYY"
    )} ${value}`;
    let startTime = moment(moment(), "DD-MM-YYYY hh:mm A");
    let endTime = moment(selectedData, "DD-MM-YYYY hh:mm A");

    let minutesDiff = endTime.diff(startTime, "minutes");

    let userType = localStorage.getItem("user_type");

    if (userType === "doctor" || userType === "staff") {
      if (!slotObj?.is_walkin) {
        if (minutesDiff > 0) {
          setLessThan(false);
        } else {
          setLessThan(true);
          setErrorTime("1 min");
        }
      }
    } else {
      if (minutesDiff > 15) {
        setLessThan(false);
      } else {
        setLessThan(true);
        setErrorTime("15 mins");
      }
    }
  };

  const handelSave = () => {
    if (lessThan15) {
      swal({
        title: "Error",
        icon: "error",
        text:
          "Appointment can be booked only " +
          errorTime +
          " prior to the start time.",
      });
    } else {
      if (showPremiumSlotSelection && !hasResourceAccess && !addBooking) {
        checkErrors();
        if (checkStartTimeIsBeforeCurrent()) {
          props.handleContinueClick(1);
        }
      } else {
        props.handleContinueClick(1);
      }
    }
  };

  // Create UI ==>

  const checkButtonDisable = () => {
    if (hasResourceAccess || addBooking) {
      let disable = disableSaveBtn;
      for (const obj of selectedProcedureList) {
        if (obj.custom_slot) {
          if (
            !obj.alloted_custom_slot ||
            !obj?.alloted_custom_slot?.startTime ||
            !obj?.alloted_custom_slot?.endTime
          ) {
            disable = true;
            break;
          }
        } else {
          if (obj.appointment_slot_id === "" || obj?.status === "failure") {
            disable = true;
            break;
          }
        }
      }
      return disable;
    } else {
      if (!showPremiumSlotSelection) {
        return props.selectedSlot === "";
      } else {
        return (
          !(allotedPremiumSlot?.startTime && allotedPremiumSlot?.endTime) ||
          !checkStartTimeIsBeforeCurrent()
        );
      }
    }
  };

  const checkStartTimeIsBeforeCurrent = () => {
    let dateTime = `${allotedPremiumSlot?.startDate} ${allotedPremiumSlot?.startTime}`;
    let currentDateTime = moment().format("YYYY-MM-DD hh:mm A");
    let startDateTime = moment(dateTime).format("YYYY-MM-DD hh:mm A");
    return moment(startDateTime).isSameOrAfter(moment(currentDateTime));
  };

  const checkErrors = () => {
    let err = { ...errors };
    const currentDate = moment(calenderDate);
    const startTime = moment(
      `${currentDate.format("YYYY-MM-DD")} ${timer.start_hr}:${
        timer.start_min
      } ${timer.start_meridian}`,
      "YYYY-MM-DD hh:mm A"
    );
    const endTime = moment(
      `${currentDate.format("YYYY-MM-DD")} ${timer.end_hr}:${timer.end_min} ${
        timer.end_meridian
      }`,
      "YYYY-MM-DD hh:mm A"
    );

    err.start_error = "";
    err.end_error = "";
    const currentTime = moment().startOf("minute");
    // Validation 1: Check if start time is before current time
    if (startTime.isBefore(currentTime)) {
      err.start_error = "Please enter a valid time";
      err.end_error = "Please enter a valid time";
    }

    // Validation 2: Check if start time and end time are both 00:00
    if (
      timer.start_hr === "00" &&
      timer.start_min === "00" &&
      timer.start_meridian.toLowerCase() === "am" &&
      timer.end_hr === "00" &&
      timer.end_min === "00" &&
      timer.end_meridian.toLowerCase() === "am"
    ) {
      err.start_error = "Please enter a valid time";
      err.end_error = "Please enter a valid time";
    }

    // Validation 3: Check if end time is ahead of start time
    if (endTime.isBefore(startTime)) {
      err.start_error = "Please enter a valid time";
      err.end_error = "Please enter a valid time";
    }

    // Validation 4: Check if start time and end time are the same
    if (startTime.isSame(endTime)) {
      err.start_error = "Please enter a valid time";
      err.end_error = "Please enter a valid time";
    }
    setErrors(err);
  };

  const isPremiumToggleDisabled = () => {
    if (hasResourceAccess || addBooking) {
      return selectedProcedureList.length == 0;
    }
    return false;
  };

  const onApplyingPremiumSlot = (selectedProcedure) => {
    checkErrors();
    setCalenderDate(calenderDate);
    let consultationSettingsId = null;
    if (hasResourceAccess || addBooking) {
      if ([0, 1, 5, 6].indexOf(selectedResourceProcedure?.id) > -1) {
        consultationSettingsId = selectedResourceProcedure?.id;
      }
    } else if ([0, 1, 5, 6].indexOf(apiSelectedConsultation?.value) > -1) {
      consultationSettingsId = apiSelectedConsultation?.value;
    }
    let procedureSettingsId = null;
    if (hasResourceAccess || addBooking) {
      if ([0, 1, 5, 6].indexOf(selectedResourceProcedure?.id) === -1) {
        procedureSettingsId = selectedResourceProcedure?.id;
      }
    } else if ([0, 1, 5, 6].indexOf(apiSelectedConsultation?.value) === -1) {
      procedureSettingsId = apiSelectedConsultation?.value;
    }
    let selectedSlots = null;
    const uniqueStartTimes = new Set();

    selectedProcedureList.forEach((item) => {
      let start_time = "";
      let start_date = "";

      if (item.custom_slot) {
        const alloted = item?.alloted_custom_slot || {};
        start_time = alloted?.startTime || "";
        start_date = alloted?.startDate || "";
      } else {
        start_time = item?.start_time || "";
        start_date = moment(selectedDate?.meta?._d)?.format("YYYY-MM-DD") || "";
      }

      const uniqueKey = `${start_date}/${start_time}`; // Unique key for Set

      if (start_time && start_date && !uniqueStartTimes.has(uniqueKey)) {
        uniqueStartTimes.add(uniqueKey); // Add unique key to Set
      }
    });
    const dateToTimes = {};

    // Create an array of objects with unique start times and dates, converting time to desired format
    const startTimesArray = Array.from(uniqueStartTimes)?.map((key) => {
      const [start_date, raw_start_time] = key?.split("/");

      // Convert "hh:mm A" to "HH:mm:ssZ"
      const start_time = moment(raw_start_time, "hh:mm A").format("HH:mm:ssZ");
      if (!dateToTimes[start_date]) {
        dateToTimes[start_date] = [];
      }
      dateToTimes[start_date].push(start_time);
    });
    selectedSlots = dateToTimes;

    let payload = {
      date: moment(calenderDate).format("YYYY-MM-DD"),
      start_time: moment(
        `${timer.start_hr}:${timer.start_min} ${timer.start_meridian}`,
        "hh:mm A"
      ).format("HH:mm:ssZ"),
      end_time: moment(
        `${timer.end_hr}:${timer.end_min} ${timer.end_meridian}`,
        "hh:mm A"
      ).format("HH:mm:ssZ"),
      doctor_id: props?.doctor.doctor_id,
      clinic_id: localStorage.getItem(LOCALSTORAGEKEY.CLINIC_ID),
      consultation_settings_id: consultationSettingsId,
      procedure_settings_id: procedureSettingsId,
      slots: selectedSlots,
    };
    c2cPostApiHandler("api/v1/premium-slot", payload).then(([res, err]) => {
      if (!err) {
        if (res?.status === 200) {
          if (res?.data?.statusCode === 200) {
            let slotInfo = res?.data;
            if (hasResourceAccess || addBooking) {
              let selected = [...selectedProcedureList];
              let filtered = selected.filter((obj) => {
                if (!obj.common_procedure && obj.id === selectedProcedure.id) {
                  return obj;
                }
                if (
                  obj.common_procedure &&
                  obj?.doctor_id === selectedProcedure.doctor_id
                ) {
                  return obj;
                }
              });
              filtered.forEach((obj) => {
                obj["alloted_custom_slot"] = {
                  startTime:
                    slotInfo?.start_time &&
                    moment(slotInfo?.start_time, "HH:mm:ssZ").format("hh:mm A"),
                  endTime:
                    slotInfo?.end_time &&
                    moment(slotInfo?.end_time, "HH:mm:ssZ").format("hh:mm A"),
                  slot_id: slotInfo?.slot_id,
                  startDate: slotInfo?.date,
                };
                obj["custom_slot"] = true;
              });
              setSelectedProcedureList(selected);
              if (isLeadBooking) {
                setAllotedPremiumSlot({
                  startTime:
                    slotInfo?.start_time &&
                    moment(slotInfo?.start_time, "HH:mm:ssZ").format("hh:mm A"),
                  endTime:
                    slotInfo?.end_time &&
                    moment(slotInfo?.end_time, "HH:mm:ssZ").format("hh:mm A"),
                  slot_id: slotInfo?.slot_id,
                  startDate: slotInfo?.date,
                });
              }
            } else {
              setAllotedPremiumSlot({
                startTime:
                  slotInfo?.start_time &&
                  moment(slotInfo?.start_time, "HH:mm:ssZ").format("hh:mm A"),
                endTime:
                  slotInfo?.end_time &&
                  moment(slotInfo?.end_time, "HH:mm:ssZ").format("hh:mm A"),
                slot_id: slotInfo?.slot_id,
                startDate: slotInfo?.date,
              });
            }
            setShowAllotedPremiumSlot(true);
          } else {
            if (res?.data?.message) {
              swal({
                title: "Error",
                text: res.data.message,
                type: "error",
                icon: "error",
                button: "OK",
              });
            }
          }
        }
      }
    });
  };

  return (
    <>
      {pgLoading ? (
        <div className="text-center">
          <img src={require("../../assets/C2C Loader.gif")} alt="Loading" />
        </div>
      ) : (
        <div
          className={`${
            (addBooking || hasResourceAccess) &&
            "booking-calendar-add-booking-resource"
          }`}
        >
          <div>
            <div>
              <div className={`row  date-time-selector-wrapper divider-b `}>
                <div
                  className={`${
                    !hasResourceAccess && !addBooking ? "col-lg-4" : "col-lg-6"
                  } col-12 d-flex flex-row justify-content-start align-items-center dts-date`}
                >
                  <div className="cal-width">
                    <div
                      className={
                        "booking-date" +
                        (!addBooking ||
                          isAbhaTokenBooking ||
                          allowCalendarChange)
                          ? "cursor-pointer"
                          : ""
                      }
                      onClick={() =>
                        (!addBooking ||
                          isAbhaTokenBooking ||
                          allowCalendarChange) &&
                        setShowCalendar(!showCalendar)
                      }
                    >
                      <span className="week-day">
                        {moment(calenderDate).format("dddd, ")}
                      </span>
                      <span
                        className="cal-date ml-2 pb-1"
                        style={{ borderBottom: "1px dotted" }}
                      >
                        {moment(calenderDate).format("DD MMM, YYYY")}
                        <span className="ml-2 c">
                          <img
                            src={CalenderIcon}
                            alt="calender icon"
                            style={{ marginBottom: "4px" }}
                          />
                        </span>
                      </span>
                      <span className="ml-1">
                        <img src={DownArrowIcon} alt="calender arrow" />
                      </span>
                    </div>
                    <div className="calendar-wrapper">
                      <Calendar
                        className={showCalendar ? "" : "hide"}
                        onChange={handleDate}
                        value={calenderDate}
                        minDate={new Date()}
                        maxDate={moment(new Date()).add(12, "months")._d}
                      />
                    </div>
                  </div>
                </div>
                {middleContent && middleContent()}
                <div
                  className={`${
                    !hasResourceAccess && !addBooking ? "col-lg-3" : "col-lg-6"
                  } col-12 date-time-selector-wrapper-premium-toggle dts-premium`}
                >
                  <div className="d-flex px-1 justify-content-lg-center align-items-center">
                    <div className="toggle-switch-icon">
                      <IOSSwitch
                        checked={showPremiumSlotSelection}
                        name="premium-toggle"
                        onChange={handlePremiumToggleSwitch}
                        disabled={isPremiumToggleDisabled()}
                      />{" "}
                    </div>
                    <p className="m-0 text-nowrap">Book Customised Time</p>
                  </div>
                </div>
                {!hasResourceAccess && !addBooking && (
                  <div className="col-lg-5 col-12 d-flex flex-lg-row flex-column justify-content-lg-end justify-content-start align-items-lg-center align-items-start">
                    <label className="pt-2 mr-2">Consultation Type:</label>
                    <div className="col-lg-7 col-10 select-max-width">
                      <CustomSelect
                        className="w-100 consultation-type"
                        name="select_consultation_type"
                        value={apiSelectedConsultation}
                        handleChange={handleConsultationType}
                        options={
                          props.appointmentType == "in-clinic"
                            ? inClinicConsultationType
                            : onlineConsultationType
                        } //consultationTypes
                        showSearch={
                          props.appointmentType == "in-clinic" ? true : false
                        }
                        isSearchable={
                          props.appointmentType == "in-clinic" ? false : true
                        }
                        placeholder="Select Consultation Type"
                        noOptionsMessage={
                          props.appointmentType == "in-clinic"
                            ? "No Procedure Found"
                            : "No Record Found"
                        }
                      />
                    </div>
                  </div>
                )}
              </div>

              {selectedProcedureList?.length > 0 && (
                <ResourceChipSection
                  selectedProcedureList={selectedProcedureList}
                  selectedResourceProcedure={selectedResourceProcedure}
                  handleSelectChip={handleSelectChip}
                  handleRemoveChip={handleRemoveChip}
                />
              )}
              {(hasResourceAccess || addBooking) &&
              selectedProcedureList.length == 0 ? (
                <div className="no_data-found_wrapper">
                  {" "}
                  <NoDataComponent
                    image={SelectDoctor}
                    heading={`Select ${
                      addBooking && selectedBookingType === "Clinic"
                        ? "Doctor"
                        : "Resource"
                    } And Procedure`}
                    message={`Please select ${
                      addBooking && selectedBookingType === "Clinic"
                        ? "doctor"
                        : "resource"
                    } and procedure to book appointment`}
                  />
                </div>
              ) : (
                <BookSchedule
                  apiConsultationType={apiSelectedConsultation}
                  bookingFromFollowUpDashboard={bookingFromFollowUpDashboard}
                  doctorId={props.doctor.doctor_id}
                  hideAnnotation={true}
                  fromCalender={fromCalender}
                  track={track}
                  calenderDate={calenderDate}
                  dashboardSelectedDate={dashboardSelectedDate}
                  retainedSlot={retainedSlot}
                  retainedSlotObj={retainedSlotObj}
                  onDateSelect={(e) => {
                    // Refresh slots on date selection
                    setCalenderDate(e.meta._d);
                    if (e) {
                      setSelectedDate(e);
                      if (hasResourceAccess) {
                        handleDateToResetResource &&
                          handleDateToResetResource(
                            moment(e.meta._d).format("DD-MM-YYYY")
                          );
                      }
                    }
                  }}
                  onSlotSelect={(e, date, slotObj) => {
                    // Get selected slot
                    if (e) {
                      props.selectedSlotCallback(e, selectedDate, slotObj);
                    }
                  }}
                  getSlotTime={getSlotTime}
                  handleSlotToEMpty={props.handleSlotToEMpty}
                  type={props.type}
                  className="mr-btm"
                  handleDate={handleDate}
                  selectedResourceProcedure={selectedResourceProcedure}
                  handleSelectResourceSlot={handleSelectResourceSlot}
                  hasResourceAccess={hasResourceAccess}
                  addBooking={addBooking}
                  booking_type={booking_type}
                  isAbhaTokenBooking={isAbhaTokenBooking}
                  showPremiumSlotSelection={showPremiumSlotSelection}
                  timer={timer}
                  setTimer={setTimer}
                  errors={errors}
                  setErrors={setErrors}
                  onApplyingPremiumSlot={onApplyingPremiumSlot}
                  showAllotedPremiumSlot={showAllotedPremiumSlot}
                  allotedPremiumSlot={allotedPremiumSlot}
                  selectedProcedureList={selectedProcedureList}
                  setDuration={setDuration}
                  setAllotedPremiumSlot={setAllotedPremiumSlot}
                  isLeadBooking={isLeadBooking}
                  followUpBooking={followUpBooking}
                />
              )}
            </div>

            {(((hasResourceAccess || addBooking) &&
              selectedProcedureList.length != 0) ||
              (!hasResourceAccess && !addBooking)) && (
              <div className={SaveBtnContainerClassName}>
                <button
                  className="btn primary-cta-button rounded-pill py-2 px-4"
                  disabled={checkButtonDisable()}
                  onClick={() => handelSave()}
                >
                  Save &amp; Continue
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}

export default BookingCalendar;
